import { render, staticRenderFns } from "./LandingPage.vue?vue&type=template&id=b946e6b0&scoped=true"
import script from "./LandingPage.vue?vue&type=script&lang=js"
export * from "./LandingPage.vue?vue&type=script&lang=js"
import style0 from "./LandingPage.vue?vue&type=style&index=0&id=b946e6b0&prod&lang=scss&scoped=true"
import style1 from "./LandingPage.vue?vue&type=style&index=1&id=b946e6b0&prod&lang=scss"
import style2 from "./LandingPage.vue?vue&type=style&index=2&id=b946e6b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b946e6b0",
  null
  
)

export default component.exports